import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  currentProductionEnvName: 'app_production',
  intercomAppId: 'n7r8ak42',
  enableIntercom: 'true',
  noolaKey: '$$ZGUI_DATA_NOOLA_KEY$$',
  enableNoola: '$$ZGUI_DATA_ENABLE_NOOLA$$',
  documentationUrl: '$$ZGUI_DATA_DOCS_URL$$',
  projectInfoUrl: '$$ZGUI_DATA_PROJECT_INFO_URL$$',
  forceSecuredWebsocket: true,
  versionInfoPath: '/assets/version.json',
  rollbarAccessToken: 'd270c426ea76465781ad6bb512eb7ef0',
  envName: 'futon',
  appVersion: 'devel',
  githubAuthCallbackUrl: 'https://futon.devel.zerops.dev/github-auth',
  gitlabAuthCallbackUrl: 'https://futon.devel.zerops.dev/gitlab-auth',
  apiUrl: 'https://api.app-futon.zerops.dev/api/rest/public',
  webApiUrl: 'https://api.zerops.io',
  websocketHost: 'api.app-futon.zerops.dev',
  websocketLoginUrl: 'https://api.app-futon.zerops.dev/api/rest/public/web-socket/login',
  googleSiteKey: '6LdUw48UAAAAALnxsH_vUxMNlAVWrCvd-OS-g2nC',
  stripePublishableKey: 'pk_test_51U65SSPvfcFXQrZAB8NNV0SVfE57QKyPDHNmKG5j2GjoiIrBu37qwFLBAABvatBxhdBEEAZSIKRSfgvLp7TEAb3f00nB5hQi00',
  sharedIPv4: '$$ZGUI_DATA_SHARED_IPV4$$',
  region: 'zerops',
  hideVersionWarning: '$$ZGUI_HIDE_VERSION_WARNING$$',
  enableRemoteShell: '$$ZGUI_ENABLE_REMOTE_SHELL$$',
  enableMultiregion: '$$ZGUI_DATA_ENABLE_MULTIREGION$$',
  enableControlPlane: 'true',
  enableRecipesCategories: '$$ZGUI_ENABLE_RECIPES_CATEGORIES$$',
  enableRecipesLinks: '$$ZGUI_ENABLE_RECIPES_LINKS$$',
  turnstileToken: '0x4AAAAAABkfatE2McOoVj6p',
  cookieDomain: '$$ZGUI_DATA_COOKIE_DOMAIN$$',
  zcpVersion: '$$ZGUI_DATA_ZCP_VERSION$$',
  enableMultiAgentHandoff: '$$ZGUI_ENABLE_MULTI_AGENT_HANDOFF$$',
  simulateZcpPoolClaim: '$$ZGUI_ENABLE_SIMULATE_ZCP_POOL_CLAIM$$'
};
